import AOS from 'aos';
//import 'aos/dist/aos.css';

var aosDelay = 0;
var aosIncrement = 200;

$('body:not(.disable-animate) .related-content').each(function(index){
	aosDelay = 0;
	var thisSliderID = $(this).attr('id');
	$('#' + thisSliderID + ' .slide[data-aos]').each(function() {
		$(this).attr('data-aos-delay', aosDelay);
	    aosDelay = aosDelay + aosIncrement;
	});
});
$('body:not(.disable-animate) .featured_50_50').each(function(index){
	aosDelay = 0;
	var thisFeatured5050 = $(this).attr('id');
	$('#' + thisFeatured5050 + ' .column[data-aos]').each(function() {
		$(this).attr('data-aos-delay', aosDelay);
	    aosDelay = aosDelay + aosIncrement;
	});
});

$('.toggle-animation').on('click',function() {
	toggleAnimation();
});

function toggleAnimation() {
	$('body').toggleClass('disable-animate');
	if($('body').hasClass('disable-animate')) {
		disableAOS();
	} else {
		enableAOS();
	}
	AOS.refreshHard();

}

function disableAOS() {
	localStorage.setItem("animationOff","true");	
	AOS.init({
		disable: true
	});
}
function enableAOS() {
	localStorage.setItem("animationOff","false");	
	AOS.init({
		disable: false,
		duration: 800,
		offset: 20,
		once: true
	});
}

$(document).ready(function() {
	if ((localStorage.getItem("animationOff") !== null) && (localStorage.getItem("animationOff") == "true")) {
		$('body').toggleClass('disable-animate');
		disableAOS();
		AOS.refreshHard();
	}
	if($(window).width() < 1024) {
		disableAOS();
		AOS.refreshHard();
	}
	$('.toggle-animation').on('keydown',function(e) {
	    if(e.keyCode == 32){
			e.preventDefault();
			toggleAnimation();
		}
	});

});
